import React, { Component } from 'react'
import styled from 'styled-components'
import { Formik, Form, Field } from 'formik'
import {
  Header,
  Footer,
  Card,
  XXLText,
  XXMText,
  ProgressBar,
  FlexWrapper,
  CustomSlider,
  TopSection,
  Overlay,
  ProductView,
  Button,
  GraphBar,
  Input,
  DefaultText,
  XMText,
  BgImage,
  Wrapper,
  Div,
  Modal,
  XCMText,
  SecondaryHeader
} from '../components'
import { gsCalculator, priceRangeCalculator, filterHiddenData, isAdmin } from '../utlis/functions'
import axios from 'axios'
import Cookies from 'js-cookie'
import { API_URL } from '../constants'
import {
  round,
  last,
  find,
  truncate,
  isEmpty,
  capitalize,
  indexOf,
  flatMap,
  toUpper,
  get,
  flatten,
  reverse,
  debounce,
  orderBy,
  pick,
  uniqBy,
  map,
  size,
  has,
  lowerCase,
  intersection
} from 'lodash'
import qs from 'qs'

const SectionWrap = styled.div`
  & > div:first-child {
    position: relative;
    z-index: 9;
  }
`
const SectionWrapper = styled.div`
  background: ${props => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  padding-bottom: 26px;
`

const SearchWrap = styled.div`
  margin: 10px 0 24px;
  overflow: auto;
  height: calc(100% - 200px);
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #124b5f;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
  /* & > div {
    margin-bottom: 0;
    /* padding: 10px 16px 10px; */
    border-radius: 0;
    &:first-child > div:last-child {
      border-radius: 5px 5px 0 0 !important;
    }
    &:last-child > div:last-child {
      border-radius: 0 0 5px 5px !important;
    }
    & > div:last-child {
      margin-bottom: 0 !important;
      border-radius: 0px !important;
    }
  } */
`

/* const StyledPageWrapper = styled(PageWrapper)`
  &:before {
    content: '';
    width: 100%;
    height: 330px;
    background: ${props => (props.scroll ? 'transparent' : '#124b5f')};
    position: absolute;
    left: 0;
    top: 0;
    -webkit-transition: background-color 0.1s ease-in;
    -moz-transition: background-color 0.1s ease-in;
    -o-transition: background-color 0.1s ease-in;
    transition: background-color 0.1s ease-in;
  }
` */
const Outer = styled.div`
  border-left: 1px solid #124b5f;
  border-bottom: 1px solid #124b5f;
  width: 100%;
  & > div:nth-child(4) {
    &:before {
      content: '0';
      position: absolute;
      left: -10px;
      top: 20px;
      font-size: 9px;
      line-height: 1.56;
      color: rgba(18, 75, 95, 0.49);
    }
  }
`
const Section = styled.div`
  border-top: 1px solid rgba(18, 75, 95, 0.07);
  height: 25px;
  position: relative;
  &:after {
    content: '${props => props.yAxis}';
    position: absolute;
    left: -15px;
    top: -10px;
    font-size: 9px;
    line-height: 1.56;
    color: rgba(18, 75, 95, 0.49);
  }
`
const StatsWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`

/* const InnerCircle = styled.div`
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 50%;
` */
const GraphFlex = styled(FlexWrapper)`
  position: absolute;
  bottom: 48px;
  left: 30px;
  /*   bottom: 0px;
  left: 10px; */
`
const PageTopWrap = styled.section`
  overflow-y: auto;
  padding-bottom: 68px;
  padding-top: 60px;
`
const CardWrap = styled.div`
  background: #078489;
  padding: 10px 16px 30px;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 190px;
    left: 0;
    top: 290px;
    background: #f7f1e3;
    transform: skewY(-10deg);
    @media (min-width: 380px) {
      top: 280px;
    }
  }
`
/* const Background = styled.div`
  background: #124b5f;
  // position: relative;
  height: 250px;
  &:after {
    content: '';
    width: 100%;
    height: 120px;
    background: #f7f1e3;
    position: absolute;
    bottom: -18px;
    transform: skewY(-2deg);
  }
` */

class Home extends Component {
  state = {
    showMessage: false,
    favorite: false,
    productsData: [],
    searchProductsData: [],
    chartData: {},
    blogData: [],
    favroitesData: [],
    search: '',
    bestScores: [],
    bestForYou: [],
    recentlySearch: [],
    bestScoresLoading: false,
    bestForYouLoading: false,
    recentlySearchLoading: false,
    comingSoonModel: false
  }
  myRef = React.createRef()
  async componentDidMount() {
    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    await this.fetchFavoritesProducts()
    await this.getFavouriteData()

    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      // console.log('userData==>', data)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
    this.fetchBestForYouData()
    this.fetchBestScores()
    this.fetchRecentlySearch()

    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}`)
      this.setState({ chartData: data })
      if (data.stage === '/dashboard/shop') {
        Cookies.set('onboarding_completed', true, { path: '/', expires: 365 })
      }
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }

    const blogQuery = {
      filter: {
        limit: 1
      }
    }
    try {
      const { data } = await axios.get(
        `${API_URL}/Blogs?access_token=${Cookies.get('access_token')}&${qs.stringify(blogQuery)}`
      )
      this.setState({ blogData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  fetchBestScores = async () => {
    this.setState({ bestScoresLoading: true })

    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              totalGs: {
                gte: 80
              }
            },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          totalGs: {
            gte: 80
          }
        }
    const query = {
      filter: {
        where: selectedStoresFilter,
        order: ['totalGs DESC'],
        limit: 200,
        include: ['productCost', 'users']
      }
    }

    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      // const selectedStores = this.state.selectedStores
      // const newData = data.filter(
      //   item =>
      //     isEmpty(selectedStores) ||
      //     selectedStores.indexOf(get(item, 'productCost.storeName', '').replace('Insta_')) > -1
      // )

      this.setState({ bestScores: reverse(uniqBy(reverse(data), 'productType')), bestScoresLoading: false })
    } catch (error) {
      this.setState({ bestScoresLoading: false })
    }
  }
  fetchRecentlySearch = async () => {
    this.setState({ recentlySearchLoading: true })

    // fetch last 3 search queries.

    const recentSearchQuery = {
      filter: {
        where: {
          productCode: {
            neq: null
          },
          userId: Cookies.get('user_id')
        },
        order: ['date DESC'],
        limit: 10
      }
    }

    const productSearch = term => ({
      filter: {
        limit: 10,
        include: ['greenScores', 'productCost', 'users'],
        where: {
          productCode: term
        },
        order: ['totalGs DESC']
      }
    })

    try {
      const { data: recentlySearchedTerms } = await axios.get(
        `${API_URL}/UserRecentSearchedProducts?${qs.stringify(recentSearchQuery)}`
      )

      const products = await Promise.all(
        recentlySearchedTerms.map(async item => {
          const { data } = await axios.get(`${API_URL}/ProductTables?${qs.stringify(productSearch(item.productCode))}`)
          return data
        })
      )
      this.setState({
        recentlySearch: uniqBy(flatten(products), 'productCode'),
        recentlySearchLoading: false
      })
    } catch (error) {
      console.log(error)
      this.setState({ recentlySearchLoading: false })
    }
  }
  fetchBestForYouData = async () => {
    // TODO: Pending Selected Stores Integration
    this.setState({ bestForYouLoading: true })

    const idx = [
      'gsCategoryWeightProcessing',
      'gsCategoryWeightNutrition',
      'gsCategoryWeightFoodSafety',
      'gsCategoryWeightAnimalWelfare',
      'gsCategoryWeightHumanRights',
      'gsCategoryWeightEnvironment',
      'gsCategoryWeightTransparency'
    ]
    const userDetails = orderBy(
      map(pick(Cookies.getJSON('userDetails'), idx), (item, key) => ({ key, value: item })),
      ['value'],
      ['desc']
    ).map(item => `${item.key.replace('gsCategoryWeight', '').toLowerCase()} DESC`)
    const checkIfAllEmpty = orderBy(
      map(pick(Cookies.getJSON('userDetails'), idx), (item, key) => ({ key, value: item })),
      ['value'],
      ['desc']
    ).reduce((acc, n) => n.value + acc, 0)
    if (checkIfAllEmpty === 0) {
      this.setState({ bestForYou: [], bestForYouLoading: false })
      return
    }
    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              totalGs: {
                gte: 70
              }
            },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          totalGs: {
            gte: 70
          }
        }
    const query = {
      filter: {
        order: userDetails,
        limit: 300,
        where: selectedStoresFilter,
        include: ['productCost', 'users']
      }
    }

    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      const userDiets = get(this.state.userData, 'diets', []).map(item => lowerCase(item.diet))
      const userAllergies = get(this.state.userData, 'allergies', []).map(item => lowerCase(item.allergy))
      // const newData = data.map(item => item.product)
      const newData = data.filter(item => {
        const allergyConflicts = get(item, 'allergyConflicts', '')
          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
          .toLowerCase()
          .split(',')
          .map(item => item.trim())
        const dietConflicts = get(item, 'dietConflicts', '')
          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
          .toLowerCase()
          .split(',')
          .map(item => item.trim())
        return isEmpty(intersection(userAllergies, allergyConflicts)) && isEmpty(intersection(userDiets, dietConflicts))
      })
      this.setState({ bestForYou: uniqBy(newData, 'productType'), bestForYouLoading: false })
    } catch (error) {
      this.setState({ bestForYouLoading: false })
      console.log(error)
    }
  }

  fetchFavoritesProducts = async () => {
    const favQuery = {
      filter: {
        include: ['productCost', 'users'],
        limit: 100
      }
    }
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?${qs.stringify(favQuery)}`
      )
      this.setState({ favroitesData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      // console.log('--------', data)
      this.setState({ favouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      await this.getFavouriteData()
      await this.fetchFavoritesProducts()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      await this.getFavouriteData()
      await this.fetchFavoritesProducts()
    }
  }
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }

  render() {
    const {
      // favorite,
      // productsData,
      chartData,
      favroitesData,
      favouriteData,
      showMessage,
      searchProductsData,
      search,
      bestForYou,
      bestScores,
      recentlySearch,
      bestForYouLoading,
      recentlySearchLoading,
      bestScoresLoading,
      blogData,
      userData,
      comingSoonModel
    } = this.state
    // const userDetails = Cookies.getJSON('userDetails')
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    const greenScore =
      (chartData.gsCategoryWeightProcessing +
        chartData.gsCategoryWeightAnimalWelfare +
        chartData.gsCategoryWeightEnvironment +
        chartData.gsCategoryWeightFoodSafety +
        chartData.gsCategoryWeightHumanRights +
        chartData.gsCategoryWeightNutrition +
        chartData.gsCategoryWeightTransparency) /
      7

    return (
      <React.Fragment>
        {isEmpty(search) ? (
          <Header
            title={`Welcome ${Cookies.getJSON('userDetails').name.split(' ')[0]}!`}
            showProfile
            color="#fff"
            onClickProfile={() => this.props.history.push('/user-profile')}
          />
        ) : (
          <Header
            title={`Welcome ${Cookies.getJSON('userDetails').name.split(' ')[0]}!`}
            showProfile
            onClickProfile={() => this.props.history.push('/user-profile')}
            onClickBack={() => this.setState({ search: '' })}
            color="#fff"
          />
        )}
        {/* <PageWrapper viewPadding="60px 16px 0px" height="auto" /> */}
        {/* <Background /> */}

        <PageTopWrap>
          <FlexWrapper
            viewPadding="0 16px"
            backgroundColor={search !== '' ? 'transparent' : '#078489'}
            style={{ maxWidth: '768px' }}>
            <Formik
              enableReinitialize
              initialValues={{ search: search }}
              render={formikBag => (
                <Form style={{ width: '100%' }}>
                  <Field
                    name="search"
                    render={({ field }) => (
                      <Input
                        {...field}
                        style={{ height: '40px' }}
                        id="searchFocusId"
                        namespace="Barcode Scanner"
                        placeholder="Search products"
                        onClickWrapper={() =>
                          this.props.history.push({
                            pathname: '/products',
                            state: {
                              searchFocus: true
                            }
                          })
                        }
                        onClickIcon={() => {
                          return search ? this.setState({ search: '' }) : this.setState({ comingSoonModel: true })
                        }}
                        autoComplete="off"
                      />
                    )}
                  />
                  {formikBag.values.search && (
                    <SearchWrap>
                      {get(this.state, 'searchProductsData', []).length > 0 ? (
                        searchProductsData.map((item, index) => {
                          /* const priceRange = get(item, 'productCost', []).map(range => {
                            return {
                              value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                              zipCode: range.zipCode
                            }
                          }) */
                          const priceRange = get(item, 'productCost', []).map(range =>
                            range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                          )
                          const allergyConflicts = get(item, 'allergyConflicts', '')
                            .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                            .toLowerCase()
                            .split(',')
                            .map(item => item.trim())
                          const dietConflicts = get(item, 'dietConflicts', '')
                            .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                            .toLowerCase()
                            .split(',')
                            .map(item => item.trim())
                          return (
                            <ProductView
                              conflict={
                                !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                                !isEmpty(intersection(userDiets, dietConflicts))
                              }
                              favValue={item.users ? item.users.length : 0}
                              key={item.productCode}
                              imageUrl={item.productImage}
                              quantity={
                                size(get(item, 'productQuantity', '')) < 15
                                  ? toUpper(get(item, 'productQuantity', ''))
                                  : ''
                              }
                              productName={get(item, 'productName', '')}
                              // priceRange={priceRangeCalculatorNew(priceRange, get(userDetails, 'zipCode', ''))}
                              priceRange={priceRangeCalculator(priceRange)}
                              favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                              onFavorite={() => this.changeFavouriteData(item.productCode)}
                              progressValue={Math.round(item.totalGs, 0)}
                              isFavorite
                              onClick={() => this.props.history.push(`/products/${item.productCode}/green-score`)}
                            />
                          )
                        })
                      ) : (
                        <p style={{ textAlign: 'center' }}>No Result Found</p>
                      )}
                    </SearchWrap>
                  )}
                </Form>
              )}
            />
          </FlexWrapper>
          <SecondaryHeader clicked={this.onStoreChange} background="#078489" />
          <CardWrap>
            <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
              <Overlay showMessage={showMessage} onClick={() => this.setState({ showMessage: true })}>
                <h3>
                  {showMessage
                    ? 'Your Personal GreenScore tracking will begin once you have purchased groceries through GreenChoice or scanned your receipt after shopping in-store.'
                    : 'No data available yet'}
                </h3>
              </Overlay>
              <FlexWrapper direction="row">
                <FlexWrapper>
                  <XXLText color="#124b5f">Your GreenScore</XXLText>
                  <XXMText>Your scores are the average of all your purchases.</XXMText>
                </FlexWrapper>
                <ProgressBar
                  percentage={round(greenScore) || 0}
                  initialAnimation={true}
                  strokeWidth={14}
                  size="44px"
                  displayImage
                />
              </FlexWrapper>
              <FlexWrapper viewMargin="28px 0 24px 0">
                <Outer>
                  <Section yAxis="100" />
                  <Section yAxis="75" />
                  <Section yAxis="50" />
                  <Section yAxis="25" />
                </Outer>
                <GraphFlex direction="row" justifyContent="space-between" width="80%" className="graph">
                  <StatsWrap>
                    <GraphBar icon="strawberry" barColor={'#078489'} volume={44} label="Processing" />
                    <GraphBar icon="food" barColor={'hsl(105,85%,41%)'} volume={100} label="Nutrition" />
                    <GraphBar
                      icon="shield"
                      barColor={'hsl(14.374500000000001,85%,61.7144%)'}
                      volume={37}
                      label="Food Safety"
                    />
                    <GraphBar
                      icon="foot"
                      barColor={'hsl(37.800000000000004,85%,56.36%)'}
                      volume={60}
                      label="Animal Welfare"
                    />
                    <GraphBar
                      icon="environment"
                      barColor={'hsl(17.6505,85%,60.9656%)'}
                      volume={41}
                      label="Environment"
                    />
                    <GraphBar icon="group" barColor={'hsl(0,85%,65%)'} volume={70} label="Human Rights" />
                    <GraphBar
                      icon="eye"
                      barColor={'hsl(7.098000000000001,85%,63.3776%)'}
                      volume={26}
                      label="Transparency"
                    />
                  </StatsWrap>
                </GraphFlex>
              </FlexWrapper>
            </Card>
          </CardWrap>
          <SectionWrap>
            <SectionWrapper>
              <TopSection
                padding="20px 16px 0px"
                title="Best for You"
                subTitle="Products that match your values well"
                to={!isEmpty(bestForYou) ? '/best-for-you' : null}
              />
              {isEmpty(filterHiddenData(bestForYou)) ? (
                <Card
                  boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                  borderRadius="5px"
                  bgColor="#fff"
                  onClick={bestForYouLoading ? () => {} : () => this.props.history.push('/dashboard/values/edit')}>
                  <FlexWrapper alignItems="center" viewPadding="0 11px">
                    <h3>
                      {bestForYouLoading
                        ? 'Loading..'
                        : 'We need you to tell us your values before we can recommend products to you (:'}
                    </h3>
                  </FlexWrapper>
                </Card>
              ) : (
                <FlexWrapper viewPadding="0 11px">
                  <CustomSlider
                    itemWidth={154}
                    numberOfItems={filterHiddenData(bestForYou).slice(0, 10).length}
                    margin="4px 5px">
                    {filterHiddenData(bestForYou)
                      .slice(0, 10)
                      .map(item => {
                        /* const priceRange = get(item, 'productCost', []).map(range => {
                        return {
                          value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                          zipCode: range.zipCode
                        }
                      }) */
                        const priceRange = get(item, 'productCost', []).map(range =>
                          range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                        )

                        const allergyConflicts = get(item, 'allergyConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        const dietConflicts = get(item, 'dietConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        return (
                          <ProductView
                            conflict={
                              !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                              !isEmpty(intersection(userDiets, dietConflicts))
                            }
                            favValue={get(item, 'users', '') ? get(item, 'users.length', '') : 0}
                            key={get(item, 'productCode', '')}
                            imageUrl={get(item, 'productImage', '')}
                            quantity={
                              size(get(item, 'productQuantity', '')) < 15
                                ? toUpper(get(item, 'productQuantity', ''))
                                : ''
                            }
                            productName={capitalize(get(item, 'productName', ''))}
                            priceRange={priceRangeCalculator(priceRange)}
                            progressValue={Math.round(item.totalGs, 0)}
                            isFavorite
                            isHidden={isAdmin() && item.isHidden ? true : false}
                            favoriteActive={indexOf(favouriteDataz, get(item, 'productCode', '')) === -1 ? false : true}
                            onFavorite={() => this.changeFavouriteData(get(item, 'productCode', ''))}
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/products/${get(item, 'productCode', '')}/green-score`
                              })
                            }
                          />
                        )
                      })}
                  </CustomSlider>
                </FlexWrapper>
              )}
            </SectionWrapper>
            <SectionWrapper>
              <TopSection
                padding="20px 16px 0px"
                title="Best Scores"
                subTitle="Top scoring products"
                to="/best-scores"
              />
              {isEmpty(filterHiddenData(bestScores)) ? (
                <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
                  <FlexWrapper alignItems="center" viewPadding="0 11px">
                    <h3>{bestScoresLoading ? 'Loading..' : 'The best scoring products will show here'}</h3>
                  </FlexWrapper>
                </Card>
              ) : (
                <FlexWrapper viewPadding="0 11px">
                  <CustomSlider
                    itemWidth={154}
                    numberOfItems={filterHiddenData(bestScores).slice(0, 10).length}
                    margin="4px 5px">
                    {filterHiddenData(bestScores)
                      .slice(0, 10)
                      .map((item, index) => {
                        /* const priceRange = get(item, 'productCost', []).map(range => {
                        return {
                          value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                          zipCode: range.zipCode
                        }
                      }) */
                        const priceRange = get(item, 'productCost', []).map(range =>
                          range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                        )

                        const allergyConflicts = get(item, 'allergyConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        const dietConflicts = get(item, 'dietConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        return (
                          <ProductView
                            conflict={
                              !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                              !isEmpty(intersection(userDiets, dietConflicts))
                            }
                            key={item.productCode}
                            favValue={item.users ? item.users.length : 0}
                            imageUrl={item.productImage}
                            quantity={
                              size(get(item, 'productQuantity', '')) < 15
                                ? toUpper(get(item, 'productQuantity', ''))
                                : ''
                            }
                            productName={capitalize(item.productName)}
                            priceRange={priceRangeCalculator(priceRange)}
                            progressValue={Math.round(item.totalGs, 0)}
                            isFavorite
                            isHidden={isAdmin() && item.isHidden ? true : false}
                            favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                            onFavorite={() => this.changeFavouriteData(item.productCode)}
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/products/${item.productCode}/green-score`
                              })
                            }
                          />
                        )
                      })}
                  </CustomSlider>
                </FlexWrapper>
              )}
            </SectionWrapper>
            <SectionWrapper>
              {isEmpty(favroitesData) ? (
                <TopSection padding="20px 16px 0px" title="Favorite Products" subTitle="Your saved products" />
              ) : (
                <TopSection
                  padding="20px 16px 0px"
                  title="Favorite Products"
                  to="/favorites"
                  subTitle="Your saved products"
                />
              )}
              {isEmpty(filterHiddenData(favroitesData)) ? (
                <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
                  <FlexWrapper alignItems="center" viewPadding="0 11px">
                    <h3>No Favorites Saved</h3>
                    <Button
                      type="submit"
                      label="View Products"
                      volume="filled"
                      margin="14px 10px 0"
                      size="small"
                      onClick={() => this.props.history.push('/products')}
                    />
                  </FlexWrapper>
                </Card>
              ) : (
                <FlexWrapper viewPadding="0 11px">
                  <CustomSlider
                    itemWidth={154}
                    numberOfItems={filterHiddenData(favroitesData).slice(0, 10).length}
                    margin="4px 5px">
                    {filterHiddenData(favroitesData)
                      .slice(0, 10)
                      .map(item => {
                        /*  const priceRange = get(item, 'productCost', []).map(range => {
                        return {
                          value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                          zipCode: range.zipCode
                        }
                      }) */
                        const priceRange = get(item, 'productCost', []).map(range =>
                          range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                        )
                        const allergyConflicts = get(item, 'allergyConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        const dietConflicts = get(item, 'dietConflicts', '')
                          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                          .toLowerCase()
                          .split(',')
                          .map(item => item.trim())
                        return (
                          <ProductView
                            conflict={
                              !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                              !isEmpty(intersection(userDiets, dietConflicts))
                            }
                            favValue={item.users ? item.users.length : 0}
                            key={item.productCode}
                            imageUrl={item.productImage}
                            quantity={
                              size(get(item, 'productCost[0].productQuantity', '')) < 15
                                ? toUpper(get(item, 'productCost[0].productQuantity', ''))
                                : ''
                            }
                            productName={capitalize(item.productName)}
                            priceRange={priceRangeCalculator(priceRange)}
                            progressValue={Math.round(item.totalGs, 0)}
                            isFavorite
                            isHidden={isAdmin() && item.isHidden ? true : false}
                            favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                            onFavorite={() => this.changeFavouriteData(item.productCode)}
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/products/${item.productCode}/green-score`
                              })
                            }
                          />
                        )
                      })}
                  </CustomSlider>
                </FlexWrapper>
              )}
            </SectionWrapper>
            <TopSection
              padding="20px 16px 0px"
              title="Recently Viewed"
              subTitle="Recently viewed products"
              to="/recently-searched"
            />
            {isEmpty(filterHiddenData(recentlySearch)) ? (
              <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
                <FlexWrapper alignItems="center">
                  <h3>{recentlySearchLoading ? 'Loading..' : 'See your recently viewed products here.'}</h3>
                </FlexWrapper>
              </Card>
            ) : (
              <FlexWrapper viewPadding="0 11px 20px">
                <CustomSlider
                  itemWidth={154}
                  numberOfItems={filterHiddenData(recentlySearch).slice(0, 10).length}
                  margin="4px 5px">
                  {filterHiddenData(recentlySearch)
                    .slice(0, 10)
                    .map(item => {
                      /* const priceRange = get(item, 'productCost', []).map(range => {
                      return {
                        value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                        zipCode: range.zipCode
                      }
                    }) */
                      const priceRange = get(item, 'productCost', []).map(range =>
                        range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                      )
                      const allergyConflicts = get(item, 'allergyConflicts', '')
                        .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                        .toLowerCase()
                        .split(',')
                        .map(item => item.trim())
                      const dietConflicts = get(item, 'dietConflicts', '')
                        .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                        .toLowerCase()
                        .split(',')
                        .map(item => item.trim())
                      return (
                        <ProductView
                          conflict={
                            !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                            !isEmpty(intersection(userDiets, dietConflicts))
                          }
                          key={item.productCode}
                          favValue={item.users ? item.users.length : 0}
                          imageUrl={item.productImage}
                          quantity={
                            size(get(item, 'productCost[0].productQuantity', '')) < 15
                              ? toUpper(get(item, 'productCost[0].productQuantity', ''))
                              : ''
                          }
                          productName={capitalize(item.productName)}
                          priceRange={priceRangeCalculator(priceRange)}
                          progressValue={gsCalculator(item.greenScores)}
                          isFavorite
                          isHidden={isAdmin() && item.isHidden ? true : false}
                          favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                          onFavorite={() => this.changeFavouriteData(item.productCode)}
                          onClick={() =>
                            this.props.history.push({
                              pathname: `/products/${item.productCode}/green-score`
                            })
                          }
                        />
                      )
                    })}
                </CustomSlider>
              </FlexWrapper>
            )}

            {/* <TopSection title="Favorite Meals" />
          <CardWrapper>
            <Wrapper>
              <Div>
                <BgImage src={require('../static/images/meal.png')} />
                <Favorite active={favorite} onClick={() => this.setState({ favorite: !favorite })} />
              </Div>
              <FlexWrapper viewPadding="10px 10px 16px 10px">
                <XXXMText color="#124b5f">Cucumber Tomato Salad</XXXMText>
                <XXXXMText>
                  30 min <Pipe>|</Pipe> Easy <Pipe>|</Pipe> 2 People
                </XXXXMText>
              </FlexWrapper>
            </Wrapper>
            <Wrapper>
              <Div>
                <BgImage src={require('../static/images/meal.png')} />
                <Favorite active={favorite} onClick={() => this.setState({ favorite: !favorite })} />
              </Div>
              <FlexWrapper viewPadding="10px 10px 16px 10px">
                <XXXMText color="#124b5f">Cucumber Tomato Salad</XXXMText>
                <XXXXMText>
                  30 min <Pipe>|</Pipe> Easy <Pipe>|</Pipe> 2 People
                </XXXXMText>
              </FlexWrapper>
            </Wrapper>

          </CardWrapper>
        */}
            <TopSection
              padding="20px 16px 10px"
              title="GCNow Stories"
              to="/gcnow-stories"
              noSubtitle
              viewAllText="Read more"
            />
            {blogData.map(item => (
              <Wrapper
                marginBottom={item.id === last(blogData).id ? '0' : '0'}
                key={item.id}
                onClick={() => this.props.history.push('/gcnow-stories/role-model-victoria-eden-pt2')}
                style={{ margin: '0 16px 4px' }}>
                <Div>
                  <BgImage src={item.blogImage} height="250px" />
                </Div>
                <FlexWrapper viewPadding="20px 10px 16px 10px">
                  <DefaultText color="#000">{item.blogName}</DefaultText>
                  <FlexWrapper viewPadding="10px 0 0 0">
                    <XMText color="#777777">{truncate(item.content, { length: 150 })}</XMText>
                  </FlexWrapper>
                </FlexWrapper>
              </Wrapper>
            ))}
          </SectionWrap>
        </PageTopWrap>
        <Modal show={comingSoonModel} hide={!comingSoonModel} onClose={() => this.setState({ comingSoonModel: false })}>
          <FlexWrapper alignItems="center">
            <XCMText>Coming Soon!</XCMText>
          </FlexWrapper>
        </Modal>
        <Footer />
      </React.Fragment>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js